import { render, staticRenderFns } from "./physics.vue?vue&type=template&id=215a4bf8&"
import script from "./physics.vue?vue&type=script&lang=js&"
export * from "./physics.vue?vue&type=script&lang=js&"
import style0 from "./physics.vue?vue&type=style&index=0&id=215a4bf8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports